export default {
  title: {
    en: 'Log in',
    ar: 'تسجيل الدخول'
  },

  text: {
    en: 'Simply login with your Mcdonald’s account and discover amazing non-food rewards!',
    ar: 'قم بتسجيل الدخول باستخدام حساب ماكدونالدز الخاص بك واكتشف مكافآت مذهلة غير المأكولات!'
  },
  /* eslint-enable quotes */

  button: {
    en: 'Login',
    ar: 'سجّل دخولك'
  }
};
